import { render, staticRenderFns } from "./PembelianItem.vue?vue&type=template&id=155544d7&"
import script from "./PembelianItem.vue?vue&type=script&lang=js&"
export * from "./PembelianItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports